/* hp26 v5n/v5o (draft) – Simple Bundles "What's in the box" (snippets/hp26-bundle-contents.liquid).
   Toggle (aria-expanded/aria-controls), card popover sizing + outside-click/Escape close, lazy thumbnails
   from /products/<handle>.js for any list item whose thumbnail slot is empty (all_products is capped at 20/page). */
(() => {
  if (window.__hp26bc) return;
  window.__hp26bc = true;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const fill = (panel) => {
    if (panel.dataset.filled) return;
    panel.dataset.filled = '1';
    panel.querySelectorAll('[data-handle]').forEach((li) => {
      const th = li.querySelector('.hp26-bc__th,.hp26-mb__th');
      if (!th || th.querySelector('img')) return;
      const url = root + 'products/' + encodeURIComponent(li.dataset.handle);
      // Simple Bundles keeps the handle from when the bundle was saved; a renamed product 404s on .js but its page 301s,
      // so ask for the page first (HEAD follows the redirect) and read the .js of wherever it lands.
      fetch(url, { method: 'HEAD', credentials: 'same-origin' })
        .then((h) => (h.ok ? fetch((h.url ? h.url.split('?')[0] : url) + '.js', { credentials: 'same-origin' }) : null))
        .then((r) => (r && r.ok ? r.json() : null))
        .then((p) => {
          if (!p || !p.featured_image) return;
          const img = new Image(56, 56);
          const u = p.featured_image.replace(/^\/\//, 'https://');
          img.src = u + (u.includes('?') ? '&' : '?') + 'width=120';
          img.alt = ((li.querySelector('a') || {}).textContent || p.title).trim();
          img.loading = 'lazy';
          img.decoding = 'async';
          th.appendChild(img);
        })
        .catch(() => {});
    });
  };
  const panelOf = (b) => document.getElementById(b.getAttribute('aria-controls'));
  const isCard = (panel) => panel && panel.dataset.ctx === 'card';
  const setOpen = (b, open) => {
    const panel = panelOf(b);
    if (!panel) return;
    b.setAttribute('aria-expanded', String(open));
    if (open && isCard(panel)) {
      const card = b.closest('.card,product-card') || b.parentElement;
      const space = b.getBoundingClientRect().top - card.getBoundingClientRect().top - 6;
      panel.style.maxHeight = Math.max(120, Math.round(space)) + 'px';
    }
    panel.hidden = !open;
    if (open) fill(panel);
  };
  const closeCards = (except) => {
    document.querySelectorAll('.hp26-bc--card [data-mb-tog][aria-expanded="true"]').forEach((b) => {
      if (b !== except) setOpen(b, false);
    });
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-mb-tog]');
    if (b) {
      const open = b.getAttribute('aria-expanded') !== 'true';
      if (open) closeCards(b);
      setOpen(b, open);
      return;
    }
    if (!e.target.closest('.hp26-bc--card .hp26-bc__panel')) closeCards(null);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = document.querySelector('.hp26-bc--card [data-mb-tog][aria-expanded="true"]');
    if (open) { setOpen(open, false); open.focus(); }
  });
  // PDP / box panels rendered open on the server: fill their thumbnails once the page has loaded
  const initOpen = () => document.querySelectorAll('[data-mb-tog][aria-expanded="true"]').forEach((b) => { const p = panelOf(b); if (p && !p.hidden) fill(p); });
  if (document.readyState === 'complete') initOpen(); else addEventListener('load', initOpen);
})();
